import { useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";

import { swal, typeChecker } from "../../../utils/methods";
import { _post } from "../../../utils/network";

import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb.component';
import FormField from "../../../components/Form/FormField/FormField.component";
import LoadingButton from '../../../components/LoadingButton/LoadingButton.component';
import ConfirmModal from "../../../components/Modals/ConfirmModal/ConfirmModal.component";

const UsersCreate = () => {
	const { t } = useTranslation();
	const breadcrumbItems = [
		{ title: t('dashboard'), link: '/dashboard' },
		{ title: t('users'), link: '/users-list' },
		{ title: t('create') }
	];
	const confirmSwal = statements => {
		swal(() => statements(), {
			text: t('are_you_sure_to_do_this'),
			confirmButtonText: t('yes'),
			cancelButtonText: t('no')
		});
	};

	const [userSelectedType, setUserSelectedType] = useState(0);
	const userTypeOnChangeHandler = event => {
		setUserSelectedType(event.target.value);
	};

	const [createButtonIsLoading, setCreateButtonIsLoading] = useState(false);
	const createUser = event => {
		event.preventDefault();
		if(createButtonIsLoading)
			return 0;
		let code = event.target.userCode.value.trim();
		if(parseInt(userSelectedType)){
			if(!code || !typeChecker(code, 'number'))
				return toast.warn(t('enter_trade_code_correctly'));
		}
		else{
			if(!typeChecker(code, 'national_id'))
				return toast.warn(t('enter_national_id_correctly'));
		}
		let type = parseInt(event.target.userType.value);
		let body = {
			user_type: type,
			user_code: code
		};
		confirmSwal(async () => {
			setCreateButtonIsLoading(true);
			let response = await _post('/users/admin/add', body);
			setCreateButtonIsLoading(false);
			switch(response.code){
				case 200:
					toast.success(response[t('api_message')]);
					event.target.reset();
					break;
				default:
					toast.error(response[t('api_message')]);
			}
		});
	};

	const userTypes = [
		{ key: t('individual_personality'), value: 0 },
		{ key: t('firm_personality'), value: 1 }
	];
	
	return <>
		<Breadcrumb items={breadcrumbItems} />
		<div className="card mb-3">
			<div className="card-header">
				<h5 className="mb-0">{t('create')} {t('user')}</h5>
			</div>
			<div className="card-body bg-light">
				<form onSubmit={createUser}>
					<div className="row gx-2">
						<FormField type="select" fieldKey="userType" title={t('type')} selectItems={userTypes} required rtl selectOnChange={userTypeOnChangeHandler} />
						<FormField fieldKey="userCode" title={parseInt(userSelectedType) ? t('trade_code') : t('national_id')} required ltr />
					</div>
					<div>
						<LoadingButton className="btn btn-primary d-inline-block mt-3 me-2" type="submit" name="create" isLoading={createButtonIsLoading}>
							<i className="fa fa-save"></i> {t('create')}
						</LoadingButton>
					</div>
				</form>
			</div>
		</div>
        <ConfirmModal action={createUser} />
	</>;
};

export default UsersCreate;
